import React, { useEffect, useState } from "react";
import { EditOptionModalContainer, ModalContainer, SelectBox } from "../styled";
import axios from "axios";
import SectionHeader from "../../common/sectionTitle";
import { AiOutlineClose } from "react-icons/ai";
import useGlobalScroll from "../../../../../hooks/useGlobalScroll";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const EditOptionModal = ({ selection, setSelection, getCart }) => {
  const [options, setOptions] = useState([]);
  const [selectOption, setSelectOption] = useState({});

  const user = useSelector((state) => state?.user?.data[0]);

  useGlobalScroll();
  useEffect(() => {
    if (!selection) return;
    getOption();
  }, [selection]);

  const getOption = async () => {
    const url = "/erp/option/get";
    const body = { vendorProductId: selection.vendorProductId, admin: false };
    try {
      const res = await axios.post(url, body);
      setOptions(res.data);
      if (res.data) {
        formatOption(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const formatOption = (productOption) => {
    const init = {};
    productOption.forEach((optionGroup) => {
      const matched = optionGroup.options.find((opt) =>
        selection.options.some((selOpt) => selOpt.optionId === opt.id),
      );
      console.log(optionGroup);
      console.log(matched);
      if (matched) {
        init[optionGroup.id] = matched.id;
      }
    });
    setSelectOption(init);
  };

  // 옵션 선택 변경 핸들러
  const handleOptionChange = (optionGroupId, optionId) => {
    setSelectOption((prevState) => ({
      ...prevState,
      [optionGroupId]: optionId,
    }));
  };

  // 확인 버튼 클릭
  const handleSubmit = async () => {
    if (!validationCheck()) return;

    const updatedOptions = Object.entries(selectOption).map(([groupId, optionId]) => {
      const group = options.find((g) => g.id === parseInt(groupId));
      const option = group?.options.find((opt) => opt.id === parseInt(optionId));

      console.log(option);
      console.log(selection.options);

      const originGroupOption = selection.options.find((o) =>
        group?.options.some((opt) => Number(opt.id) === Number(o.optionId)),
      );

      return {
        id: originGroupOption?.id || null,
        optionId: option?.id,
        qty: option?.consumeCount || 1,
        name: option?.value || "",
        price: option?.addPrice || 0,
      };
    });

    const updatedProduct = {
      ...selection,
      options: updatedOptions,
    };

    await updateCart(updatedProduct);
    setSelection(null);
  };

  const validationCheck = () => {
    for (const group of options) {
      if (group.isRequired && !selectOption[group.id]) {
        toast.error(`옵션 ${chooseParticle(group.name, "을를")} 선택해주세요.`);
        return false;
      }
    }
    return true;
  };

  const updateCart = async (product) => {
    const body = {
      input: {
        id: product.id,
        mberNo: user?.mberNo,
        platform: "MULTI_PAGE",
        vendorProductId: product.vendorProductId,
        quantity: product.quantity,
        checked: product.checked,
        options: product.options.map((opt) => {
          const group = options.find((g) => g.options.some((o) => o.id === opt.optionId));

          return {
            id: opt.id,
            optionId: opt.optionId,
            qty: opt.qty,
            name: opt.name,
            price: opt.price,
            optionGroupName: group?.name || "",
          };
        }),
      },
    };

    try {
      const res = await axios.post("/erp/cart/upsert", body);
      if (res.status === 200) {
        await getCart();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ModalContainer onClick={(e) => e.target === e.currentTarget && setSelection(null)}>
      <EditOptionModalContainer>
        <div className="modal">
          <div className="form">
            <SectionHeader
              title={`옵션 수정`}
              action={{
                icon: AiOutlineClose,
                className: "close",
                clickEvent: () => setSelection(null),
              }}
            />
            <ul>
              {options.map((optionGroup) => (
                <li>
                  <div className="tit">
                    {optionGroup.name}
                    {optionGroup.isRequired && ` (필수선택)`}
                  </div>
                  <SelectBox
                    name={`optionGroup-${optionGroup.id}`}
                    value={selectOption[optionGroup.id] || ""}
                    onChange={(e) => handleOptionChange(optionGroup.id, e.target.value)}>
                    <option value="">{optionGroup.name}</option>
                    {optionGroup.options.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.value} (+{formatNumber(option.addPrice)}원)
                      </option>
                    ))}
                  </SelectBox>
                </li>
              ))}
            </ul>
          </div>
          <button className="submit" onClick={handleSubmit}>
            확인
          </button>
        </div>
      </EditOptionModalContainer>
    </ModalContainer>
  );
};

export default EditOptionModal;
